// @ts-nocheck


import {
  useDataProvider,
  useRecordContext
} from "react-admin";

import { useState } from "react";


export const JobFiles = ({resource, ...props}) => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const [files, setFiles] = useState(false);


  if (files === false) {
    dataProvider.getList('files', {
      filter: {
        'metadata.jobId': record.id,
        tags: 'autoscore-job'
      },
      pagination: { page: 1, perPage: 100 },
      sort: { field: "fileName", order: "1" }
    }).then((results) => {
      if (results.total) {
        let promises = [];

        for (let result of results.data) {
          promises.push(dataProvider.getOne('files', {id: result.id}));
        }

        return Promise.all(promises);
      }
    }).then((results) => {
      let files = [];

      if (results) {
        for (let result of results) {
          /*files.push({
            name: result.data.fileName,
            url: result.data.url
          });*/
          files.push(<li key={result.data.url}><a href={result.data.url} target="_blank">{result.data.fileName}</a></li>);
        }
      }

      setFiles(files);
    });

    return (<h5>Loading files...</h5>);
  }


  if (!files.length) {
    return (<h5>No files found.</h5>);
  }


  return (
    <ul>
      {files}
    </ul>
  );
}
